import { createWorkshopRegistration } from '@chancenwerk/workshops/api/createWorkshopRegistration.js';
import { createWorkshopRegistrationExternal } from '@chancenwerk/workshops/api/createWorkshopRegistrationExternal.js';
import { getWorkshopAttendanceByAccessToken } from '@chancenwerk/workshops/api/getWorkshopAttendanceByAccessToken.js';
import { mutationWorkshopMigration } from '@chancenwerk/workshops/api/mutationWorkshopMigration.js';
import { mutationWorkshopMigrationOnboarding } from '@chancenwerk/workshops/api/mutationWorkshopMigrationOnboarding.js';
import { sendWorkshopParticipationEmail } from '@chancenwerk/workshops/api/sendWorkshopParticipantsMail.js';
import { sendWorkshopRegistrationEmail } from '@chancenwerk/workshops/api/sendWorkshopRegistrationMail.js';
import { sendWorkshopStornoMail } from '@chancenwerk/workshops/api/sendWorkshopStornoMail.js';
import { stornoWorkshopAttendanceByAccessToken } from '@chancenwerk/workshops/api/stornoWorkshopAttendanceByAccessToken.js';
import { subscribeWorkshopAllAttendanceSimple } from '@chancenwerk/workshops/api/subscribeWorkshopAllAttendanceSimple.js';
import { subscribeWorkshopAttendance } from '@chancenwerk/workshops/api/subscribeWorkshopAttendance.js';
import { subscribeWorkshopAttendanceCount } from '@chancenwerk/workshops/api/subscribeWorkshopAttendanceCount.js';
import { subscribeWorkshopAttendanceSimple } from '@chancenwerk/workshops/api/subscribeWorkshopAttendanceSimple.js';
import { subscribeWorkshopOnboarding } from '@chancenwerk/workshops/api/subscribeWorkshopOnboarding.js';
import { subscribeWorkshopTrainingAttendance } from '@chancenwerk/workshops/api/subscribeWorkshopTrainingAttendance.js';
import { subscribeWorkshopTrainingAttendanceSimple } from '@chancenwerk/workshops/api/subscribeWorkshopTrainingAttendanceSimple.js';

export namespace WorkshopAPI {
  // Migrate
  export const migrate = mutationWorkshopMigration;
  export const migrateOnboarding = mutationWorkshopMigrationOnboarding;

  // Subscribe
  export const subscribeAllAttendanceSimple = subscribeWorkshopAllAttendanceSimple;
  export const subscribeAttendance = subscribeWorkshopAttendance;
  export const subscribeAttendanceCount = subscribeWorkshopAttendanceCount;
  export const subscribeAttendanceSimple = subscribeWorkshopAttendanceSimple;
  export const subscribeOnboarding = subscribeWorkshopOnboarding;
  export const subscribeTrainingAttendance = subscribeWorkshopTrainingAttendance;
  export const subscribeTrainingAttendanceSimple = subscribeWorkshopTrainingAttendanceSimple;

  // Mail
  export const sendRegistrationEmail = sendWorkshopRegistrationEmail;
  export const sendStornoEmail = sendWorkshopStornoMail;
  export const sendParticipationEmail = sendWorkshopParticipationEmail;

  // Registration
  export const createRegistration = createWorkshopRegistration;
  export const createRegistrationExternal = createWorkshopRegistrationExternal;

  // Other
  export const getAttendanceByAccessToken = getWorkshopAttendanceByAccessToken;
  export const stornoAttendanceByAccessToken = stornoWorkshopAttendanceByAccessToken;
}
